// extracted by mini-css-extract-plugin
export default {"root":"KPIFieldset_root__OMIvz","disabled":"KPIFieldset_disabled__XvAXH","switch":"KPIFieldset_switch__-ERtr","format":"KPIFieldset_format__gYE1s","lean":"KPIFieldset_lean__GocMC"};